import type { ReactNode } from 'react';
import { Link } from 'react-router-dom';
import logoUrl from '../../../Logo/WhatsApp Image 2026-09-02 at 09.19.41.jpeg';

type LegalShellProps = {
  eyebrow: string;
  title: string;
  children: ReactNode;
};

export default function LegalShell({
  eyebrow,
  title,
  children,
}: LegalShellProps) {
  return (
    <div className="legal-page">
      <a className="skip-link" href="#contenido-legal">
        Saltar al contenido
      </a>
      <header className="legal-header">
        <Link to="/" aria-label="Evolution by Corina, volver al inicio">
          <img src={logoUrl} alt="Evolution by Corina" />
        </Link>
        <Link className="legal-header__back" to="/">
          Volver al inicio
        </Link>
      </header>
      <main className="legal-content" id="contenido-legal">
        <p className="eyebrow">{eyebrow}</p>
        <h1>{title}</h1>
        <div className="legal-content__body">{children}</div>
      </main>
    </div>
  );
}
